import { useState, useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { GetPageAuthorityFn } from "../../Common/authority";
import { GetAllowanceHistoryActionPermission } from "../../Common/authority";
import CssClass from "../../Styles/common.module.css";
import AllowanceApprove from "../../Components/History/Allowance/AllowanceApprove";
import AllowanceRejected from "../../Components/History/Allowance/AllowanceRejected";
import AllowanceCancel from "../../Components/History/Allowance/AllowanceCancel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faPenToSquare, faEye, faCalendarCheck, faCalendarXmark, faDownload } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';

const PAGE_NAME = "AllowanceHistory.js_";
const MODULE_ID = "WEB_HIS_002";

const AllowanceHistory = (props) => {
  document.title = common.c_TITLE + " - AllowanceHistory";
  const dtRef = useRef(null);

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [allData, setAllData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]);
  const [startDateFilter, endDateFilter] = dateRangeFilter;
  const [showApprove, setShowApprove] = useState(false);
  const [showRejected, setShowRejected] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [selectedAllowance, setSelectedAllowance] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    USERNAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
    STATUS_DESC: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
    READALL: "N",
  });
  
  const [viewAuthority, setViewAuthority] = useState({
    APPROVAL: "N",
    CANCEL: "N",
    REJECT: "N",
    VIEW: "N",
  });

  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
          READALL: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
      let promise = GetAllowanceHistoryActionPermission(userId, MODULE_ID);
      promise.then(
        (result) => {
          setViewAuthority(result);
        },
        (error) => {
          setViewAuthority({
            APPROVAL: "N",
            CANCEL: "N",
            REJECT: "N",
            VIEW: "N",
          });
          common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
          toast.error(error);
        }
      );
    }, [actionAuthority, userId])

  useEffect(() => {
      if (!viewAuthority) return;
      let functionName = "";
      try {
        functionName = " Get All Support Allowance Claim History";

        setLoading(true);
        setLoadingText("Getting Record, please wait...");

        const listItems = [];
        const userIds = viewAuthority.VIEW === "Y" ? "" : userId;
        
        var newStartDate = "";
        var newEndDate = "";
        if (startDateFilter === null && endDateFilter === null) {
          newStartDate = "";
          newEndDate = "";
        } else if (startDateFilter !== null && endDateFilter === null) {
          newStartDate = common.c_Dis_DateTime(startDateFilter).val;
          newEndDate = "";
        } else {
          newStartDate = common.c_Dis_DateTime(startDateFilter).val;
          newEndDate = common.c_Dis_DateTime(endDateFilter).val;
        }

        http
          .get(
            "api/allowanceHistory/GetAllowanceList?_sysUser=" + userIds +
            "&_startDateFilter=" +
            newStartDate +
            "&_endDateFilter=" +
            newEndDate,{ timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                const isDraftStatus = data.STATUS === '2B0B24D1-3A4D-4FB6-B256-D92FA0304B0F';

                if (isDraftStatus && data.USER_MST_GUID !== userId) {
                  return; 
                }

                let formattedSubmitDate = '';

                if (data.SUBMIT_DATETIME && data.SUBMIT_DATETIME !== '0001-01-01T00:00:00') {
                  const submitDate = new Date(data.SUBMIT_DATETIME);

                  if (!isNaN(submitDate)) {
                    formattedSubmitDate =
                      submitDate.toLocaleDateString('en-GB') + ' ' + submitDate.toLocaleTimeString('en-GB', {
                          hour12: true,
                          hour: '2-digit',
                          minute: '2-digit',
                        }).toUpperCase();
                  }
                }

                const updateDate = new Date(data.UPDATE_DATETIME);
                const formattedUpdateDate =
                  updateDate.toLocaleDateString('en-GB') + ' ' + updateDate.toLocaleTimeString('en-GB', {
                    hour12: true,
                    hour: '2-digit',
                    minute: '2-digit',
                  }).toUpperCase();

                listItems.push({
                  key: data.ALLOWANCE_MST_ID,
                  ALLOWANCE_MST_ID: data.ALLOWANCE_MST_ID,
                  USER_MST_GUID: data.USER_MST_GUID,
                  USERNAME: data.USERNAME,  
									STATUS: data.STATUS,
                  STATUS_DESC:data.STATUS_DESC,
									SUBMIT_DATETIME: formattedSubmitDate,
                  TOTAL_CLAIM: data.TOTAL_CLAIM.toFixed(2),
									REASON: data.REASON,
									UPDATE_DATETIME: formattedUpdateDate,
                  UPDATE_NAME: data.UPDATE_NAME,
                });
              });
            }
            setAllData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting allowance list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
      } catch (err) {
        toast.error("Error on getting allowance list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, viewAuthority, userId]);
  
  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Status list";
      const listItems = [];
      http
        .get("api/allowanceHistory/GetStatus?_sysUser=" + userId, { timeout: 100000 })
        .then((response) => {
        const listItems = response.data.map(dayType => ({
          key: dayType.CATEGORY_TYPE_MST_ID,
          value: dayType.CATEGORY_TYPE_NAME,
          label: `${dayType.CATEGORY_TYPE_NAME}`
        }));
        setStatusList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting status list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting status list. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, [reload, userId]);
  
  const statusFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statusList}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select status"
      />
    );
  };

  //#region Event Handlers
  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };
  
  const redirectDraft = (row, action) => {
    navigate(`/AllowanceDraft?allowanceId=${row.ALLOWANCE_MST_ID}&action=${action}`);
  }

  const showApproveModal = (e, row) => {
    setShowApprove(!showApprove);
    setEditData(row);
  };
  
  const hideApproveModal = () => {
    setShowApprove(!showApprove);
    setEditData(null);
  };
  
  const showRejectedModal = (e, row) => {
    setShowRejected(!showRejected);
    setEditData(row);
  };
  
  const hideRejectedModal = () => {
    setShowRejected(!showRejected);
    setEditData(null);
  };
  
  const showCancelModal = (e, row) => {
    setShowCancel(!showCancel);
    setEditData(row);
  };
  
  const hideCancelModal = () => {
    setShowCancel(!showCancel);
    setEditData(null);
  };
  
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    
    if (!_filters['global']) {
      _filters['global'] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    }
    
    _filters['global'].value = value;
  
    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  
  const renderHeader = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Allowance History</span>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
            className="table-search-input"
            style={{ height: '40px', fontSize: '0.9rem' }}
          />
        </IconField>
      </div>
    );
  };
    
  const HighlightCell = ({ text, keyword }) => {
    if (!keyword || !text) return text;
    
    const regex = new RegExp(`(${keyword})`, "gi");
    const parts = text.split(regex);
  
    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === keyword.toLowerCase() ? (
            <span key={i} className="highlight-keyword">{part}</span>
          ) : (
            part
          )
        )}
      </>
    );
  };
        
  const TruncatedText = ({ text = '', maxLength = 0 }) => {
    const [expanded, setExpanded] = useState(false);
      
    if (!text) return null;
      
    const isLong = text.length > maxLength;
    const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + '...';
    
    return (
      <div>
        <span>{displayText}</span>
        {isLong && (
          <span
            onClick={() => setExpanded((prev) => !prev)}
            style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px' }}
          >
            {expanded ? 'Show less' : 'Read more'}
          </span>
        )}
      </div>
    );
  };

  const applyFilter = (value, filterValue, matchMode) => {
    if (!filterValue) return true;

    const val = (value || "").toString().toLowerCase();
    const filter = filterValue.toString().toLowerCase();

    switch (matchMode) {
      case "contains":
        return val.includes(filter);
      case "notContains":
        return !val.includes(filter);
      case "startsWith":
        return val.startsWith(filter);
      case "endsWith":
        return val.endsWith(filter);
      case "equals":
        return val === filter;
      case "notEquals":
        return val !== filter;
      default:
        return true;
    }
  };
    
  const onExcelHandler = (e, rowData) => {
    const selectedAllowanceId =
      rowData.ALLOWANCE_MST_ID !== undefined
        ? rowData.ALLOWANCE_MST_ID
        : "";
    window.open(
      common.c_getApiUrl() +
        "api/allowanceHistory/ExportExcel?_allowanceId=" +
        selectedAllowanceId +
        "&_sysUser=" +
        userId
    );
  };
  //#endregion

  return (
    <>
      <div style={{ margin: "8px 8px 0", padding: "5px 10px" }}>
        <table className="profileTable" style={{  width: '100%', border: '1px solid #ccc', backgroundColor: '#ffffff' }}>
          <tr>
            <td style={{ verticalAlign: "middle", width: "10%" }}>Submit Date (From-To)</td>
            <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
            <td style={{ verticalAlign: "middle", width: "35%" }}>
              <Comp.DateTimePicker 
                id="DATE_RANGE_FILTER"
                selectsRange
                onChange={(dates) => setDateRangeFilter(dates)}
                startDate={startDateFilter}
                endDate={endDateFilter}
                autoComplete="off"
              />
            </td>
          </tr>
        </table>
      </div>
      <div className={CssClass.btnWrapperTwo}>
        <Comp.Button id="btnSearch" type="general" style={{width: '140px'}} onClick={onReloadHandler}>
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          <span>&nbsp; SEARCH</span>
        </Comp.Button>
      </div>
      <div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
        <div style={{ width: "100%" }}>
          <DataTable ref={dtRef} value={allData} dataKey="ALLOWANCE_MST_ID" header={renderHeader()} globalFilter={globalFilterValue} globalFilterFields={['USERNAME', 'STATUS']} filters={filters} filterDisplay="row" 
            onFilter={(e) => { 
              const newFilters = e.filters; 
              setFilters(newFilters); 
              const globalKeyword = newFilters.global?.value || '';
              const updated = allData.map(item => ({ ...item, __FILTER_KEYWORD__: { USERNAME: newFilters.USERNAME?.value || globalKeyword, STATUS: newFilters.STATUS?.value || globalKeyword }})); 
              setAllData(updated); 
            }}
            selectionMode="multiple" selection={selectedAllowance} onSelectionChange={(e) => setSelectedAllowance(e.value)}
            loading={loading} removableSort emptyMessage="No allowance found." first={currentPage * rowsPerPage}
            paginator rows={rowsPerPage} onPage={(e) => { setCurrentPage(e.page); setRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
            scrollable scrollHeight="500px" showGridlines className="datatable" tableStyle={{ minWidth: '80rem' }}
          >
            <Column header="Action"
                body={(rowData) => (
                  <div style={{ textAlign: "left", minWidth: "220px", marginLeft: "8px" }} className={CssClass.tdBtnActionWrapperTwo}>
                    <span title="View">
                        <Comp.Button
                          id="btnView"
                          type="general"
                          onClick={() => redirectDraft(rowData, "View")}
                          style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Comp.Button>
                      </span>
                    {(rowData.STATUS === "2B0B24D1-3A4D-4FB6-B256-D92FA0304B0F") && (
                      <span title="Draft">
                        <Comp.Button
                          id="btnDraft"
                          type="general"
                          onClick={() => redirectDraft(rowData, "Draft")}
                          style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </Comp.Button>
                      </span>
                    )}
                    {(viewAuthority.APPROVAL === "Y" && rowData.STATUS === "2F917D27-2274-4509-9B9C-1A86FFFB6A45") && (
                      <span title="Approve">
                        <Comp.Button
                          id="btnApprove"
                          type="general"
                          onClick={(e) => showApproveModal(e, rowData)}
                          style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                        >
                          <FontAwesomeIcon icon={faCalendarCheck} />
                        </Comp.Button>
                      </span>
                    )}
                    {(viewAuthority.REJECT === "Y" && rowData.STATUS === "2F917D27-2274-4509-9B9C-1A86FFFB6A45") && (
                      <span title="Reject">
                        <Comp.Button
                          id="btnReject"
                          type="general"
                          onClick={(e) => showRejectedModal(e, rowData)}
                          style={{ width: "50px", height: "35px", backgroundColor: "#d40b0b" }}
                        >
                          <FontAwesomeIcon icon={faCalendarXmark} />
                        </Comp.Button>
                      </span>
                    )}
                    {(viewAuthority.CANCEL === "Y" && rowData.STATUS === "E29288AB-B30C-4039-9365-0324498F1352") && (
                      <span title="Cancel">
                        <Comp.Button
                          id="btnCancel"
                          type="general"
                          onClick={(e) => showCancelModal(e, rowData)}
                          style={{ width: "50px", height: "35px", backgroundColor: "#800080" }}
                        >
                          <FontAwesomeIcon icon={faCalendarXmark} />
                        </Comp.Button>
                      </span>
                    )}
                    {rowData.STATUS === "E29288AB-B30C-4039-9365-0324498F1352" && (
                      <span title="Export">
                        <Comp.Button
                          id="btnExport"
                          type="general"
                          onClick={(e) => onExcelHandler(e, rowData)}
                          style={{ width: "50px", height: "35px", backgroundColor: "green" }}
                        >
                          <FontAwesomeIcon icon={faDownload} />
                        </Comp.Button>
                      </span>
                    )}
                  </div>
                )}
              />
            <Column
              header="#" 
              body={(rowData, options) => options.rowIndex + 1}
              style={{ width: '3rem', height: "40px", textAlign: 'center' }}
            />
            <Column field="USERNAME" header="Name" frozen filter filterPlaceholder="Search by name" sortable
              style={{ minWidth: isMobile ? '180px' : '220px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.USERNAME} keyword={rowData.__FILTER_KEYWORD__?.USERNAME || ''} />
              )}
            />
            <Column field="STATUS_DESC" header="Status" frozen={!isMobile} filter filterElement={statusFilterTemplate} sortable
              style={{ minWidth: '220px' }} 
              body={(rowData) => (
                <span className={`status-badge ${rowData.STATUS_DESC?.toLowerCase()}`}>
                <HighlightCell text={rowData.STATUS_DESC} keyword={rowData.__FILTER_KEYWORD__?.STATUS_DESC || ''} /></span>
              )}
            />
            <Column field="SUBMIT_DATETIME" header="Submitted On" sortable style={{ minWidth: '160px' }}
              sortFunction={(e) => {
                const parseDate = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                  );
                };

                const sorted = [...e.data].sort((a, b) => {
                  const dateA = parseDate(a.SUBMIT_DATETIME);
                  const dateB = parseDate(b.SUBMIT_DATETIME);

                  return (dateA - dateB) * e.order;
                });

                return sorted;
              }}
            />
            <Column field="TOTAL_CLAIM" header="Amount (RM)" sortable style={{ minWidth: '170px', textAlign: 'right' }} bodyStyle={{ backgroundColor: '#ebf5eb', fontWeight: 'bold' }}
              filter
              showFilterMenu={false}
              filterElement={() => {
                let rowsToSum = allData;

                if (filters.USERNAME?.value) {
                  rowsToSum = rowsToSum.filter(item =>
                    applyFilter(
                      item.USERNAME,
                      filters.USERNAME.value,
                      filters.USERNAME.matchMode
                    )
                  );
                }

                if (filters.STATUS_DESC?.value) {
                  rowsToSum = rowsToSum.filter(item =>
                    applyFilter(
                      item.STATUS_DESC,
                      filters.STATUS_DESC.value,
                      filters.STATUS_DESC.matchMode
                    )
                  );
                }

                if (filters.global?.value) {
                  const keyword = filters.global.value.toLowerCase();

                  rowsToSum = rowsToSum.filter(item =>
                    item.USERNAME?.toLowerCase().includes(keyword) ||
                    item.STATUS_DESC?.toLowerCase().includes(keyword)
                  );
                }

                const total = rowsToSum.reduce(
                  (sum, item) => sum + parseFloat(item.TOTAL_CLAIM || 0),
                  0
                );

                return (
                  <div style={{ textAlign: "left", width: "100%" }}>
                    <span style={{ fontWeight: "bold" }}>
                      Total: RM {total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </div>
                );
              }}
            />
            <Column field="REASON" header="Reject / Cancel Reason" sortable style={{ minWidth: '250px' }} bodyStyle={{ backgroundColor: '#ffd9d9', color: '#c00000' }}
              body={(rowData) => 
                <TruncatedText text={rowData.REASON} maxLength={50} />
              }
            />
            <Column field="UPDATE_DATETIME" header="Last Update" sortable style={{ minWidth: '160px' }}
              sortFunction={(e) => {
                const parseDate = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                  );
                };

                const sorted = [...e.data].sort((a, b) => {
                  const dateA = parseDate(a.UPDATE_DATETIME);
                  const dateB = parseDate(b.UPDATE_DATETIME);

                  return (dateA - dateB) * e.order;
                });

                return sorted;
              }}
            />
            <Column field="UPDATE_NAME" header="Updated By" sortable style={{ minWidth: '150px' }}></Column>
          </DataTable>
        </div>
      </div>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
      {showApprove && (
        <AllowanceApprove
          page={props.page}
          module={MODULE_ID}
          showHide={showApprove}
          editData={editData}
          onHide={hideApproveModal}
          onReload={onReloadHandler}
          onLoading={onLoadingHandler}
        />
      )}

      <AllowanceRejected
        page={props.page}
        module={MODULE_ID}
        showHide={showRejected}
        editData={editData}
        onHide={hideRejectedModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <AllowanceCancel
        page={props.page}
        module={MODULE_ID}
        showHide={showCancel}
        editData={editData}
        onHide={hideCancelModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
    </>
  );
};

export default AllowanceHistory;
